export const FeatureQueryKeys = {
  all: () => ["features"],
};
